import {compose, setDisplayName} from "recompose";
import {connect} from "react-redux";
import React from "react";

import './Pagination.css'
import InputRange from "react-input-range";
import {getLocaleString} from "../../../../locale";

const mapStateToProps = (state) => ({
    pageCount: state.reader.pageCount,
})

const enhance = compose(
    setDisplayName('Pagination'),
    connect(mapStateToProps, null),
)

export class View extends React.Component {
    render() {
        const {props: {pageCount, backButton, forwardButton, onBackButton, onForwardButton, onAddRangeRef, currPage,
            onChangeStart, onChangeRange, onChangeRangeComplete}} = this
        return (
            <div className="pageCount">
                <div className={`backButton${!backButton.status ? ' hide' : ''}`} onClick={() => onBackButton()}>
                    <i className="arrow"></i>
                    <span className="page">{backButton.page}</span>
                </div>
                <div className={`goButton${!forwardButton.status ? ' hide' : ''}`} onClick={() => onForwardButton()}>
                    <span className="page">{forwardButton.page}</span>
                    <i className="arrow"></i>
                </div>
                {pageCount && currPage ?
                    <InputRange
                        ref={(node) => onAddRangeRef(node)}
                        maxValue={pageCount}
                        value={parseInt(currPage, 10)}
                        minValue={1}
                        onChangeStart={(value) => onChangeStart(value)}
                        onChange={(value) => onChangeRange(value)}
                        onChangeComplete={(value ) => onChangeRangeComplete(value)}
                    />
                    :
                    ''
                }
                <span className="pageCount-num">{pageCount ? `${currPage} ${getLocaleString('reader.of')} ${pageCount} ${getLocaleString('reader.pages')}` : ''}</span>
            </div>
        )
    }
}

export const Pagination = enhance(View)


// WEBPACK FOOTER //
// ./src/components/Reader/components/Pagination/Pagination.js